
/**
 * AUTH config
 */

const AUTH_CONFIG = {
  CHECK_INTERVAL: process.env.REACT_APP_AUTH_CHECK_INTERVAL || 60, // Default to 60 seconds if not set
};

export default AUTH_CONFIG;